import { useEffect, useState } from 'react';

export function useMatchMedia(media: string): boolean {
  const [mediaQueryList, setMediaQueryList] = useState(() => {
    return window.matchMedia('query');
  });

  const [mediaMatches, setMediaMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    if (media !== mediaQueryList.media) {
      setMediaQueryList(window.matchMedia(media));
    }
  }, [media, setMediaQueryList, mediaQueryList]);

  useEffect(() => {
    const updateQueryMatches = (): void => {
      setMediaMatches(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', updateQueryMatches);
    updateQueryMatches(); // it could have changed between creating the query and attaching the event listener

    return () => {
      mediaQueryList.removeEventListener('change', updateQueryMatches);
    };
  }, [setMediaMatches, mediaQueryList]);

  return mediaMatches;
}
